import React            from 'react';
import isEmpty          from 'lodash/isEmpty';
import ProductErrorList from 'components/product/product_error_list';

const SingleProductTarificationError = ({ tarification, className }) => {
  const acceptance = tarification.last_error_response.acceptance_errors && !isEmpty(tarification.last_error_response.acceptance_errors);
  const { last_error_response: { message } } = tarification;
  let errors = null;
  if (message === undefined) {
    errors = acceptance ? tarification.last_error_response.acceptance_errors : tarification.last_error_response.errors;
  }

  return (
    <React.Fragment>
      { message && (
        <div className="uk-alert-warning p-10">
          { message }
        </div>
      ) }
      { !message && (
        <div className={ `uk-alert-${ acceptance ? 'disabled' : 'warning' } ${ className }` }>
          <ul data-uk-accordion>
            <li>
              <a className="uk-accordion-title" href="#">
                { !acceptance && errors && (
                  <React.Fragment>
                    { t('quick_tarification.missing_data', { count: Object.keys(errors).length }) }
                    <button
                      type="button"
                      className="product-missing-data-button show"
                    >
                      { t('general.actions.see') }
                    </button>
                    <button
                      type="button"
                      className="product-missing-data-button hide"
                    >
                      { t('general.actions.hide') }
                    </button>
                  </React.Fragment>
                ) }
                { acceptance && t('quick_tarification.unavailable_product') }
              </a>
              <div className="uk-accordion-content">
                <ProductErrorList errors={ errors } />
              </div>
            </li>
          </ul>
        </div>
      ) }
    </React.Fragment>
  );
};

export default SingleProductTarificationError;
